export const PLANS_OVERVIEWS_PAGE_SIZE = 1000;
